module.exports = __webpack_public_path__ + "img/custom-software-white.7c72427d.png";